export default "__VITE_ASSET__nwz$bhLO__"